<template>
    <div class="tl video-tree">
        <template>
            <el-tabs type="border-card" v-model="tabIndex" @tab-click="handleClick" >
                <el-tab-pane name="tasks" :label="$t('promanagement_production_tasks')" style="overflow-x: auto">
                    <div v-if="tabIndex == 'tasks'">
                        <pro-details :datevalue="datevalue" :formvalue="formvalue" v-if="i_type==0"   @proDetails="proDetails"></pro-details>
                        <entrust-details :datevalue="datevalue" :formvalue="formvalue" v-if="i_type==1"  @proDetails="proDetails"></entrust-details>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="requisition" :label="$t('promanagement_application_for_requisition')" class="tabWidth">
                    <div v-if="tabIndex == 'requisition'">
                        <requisition-application :formvalue="formvalue" ref="forChildren"></requisition-application>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="feeding" :label="$t('promanagement_feeding')" class="tabWidth">
                    <div v-if="tabIndex == 'feeding'">
                        <consume-list :formvalue="formvalue" ref="consumeList" ></consume-list>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="output" :label="$t('promanagement_output_consumption')" class="tabWidth">
                    <div v-if="tabIndex == 'output'">
                        <output-consumpe :formvalue="formvalue" ref="outputConsumpe" ></output-consumpe>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="warehouse" :label="$t('promanagement_warehouse_application')" class="tabWidth">
                    <div v-if="tabIndex == 'warehouse'">
                        <warehouse-application :formvalue="formvalue" ref="warehouseApplication"></warehouse-application>
                    </div>
                </el-tab-pane>
                <!--<el-tab-pane label="退库申请"  class="tabWidth">
                    <div v-if="tabIndex == 5">
                        <stockreturn-list :formvalue="formvalue" ref="stockreturnlist"></stockreturn-list>
                    </div>
                </el-tab-pane>-->
<!--                <el-tab-pane name="deliver" :label="$t('promanagement_deliver')"  class="tabWidth" :disabled="i_type!=1">-->
<!--                    <div v-if="tabIndex == 'deliver'"  v-show="i_type==1">-->
<!--                        <deliver-list :formvalue="formvalue" ref="deliverList"></deliver-list>-->
<!--                    </div>-->
<!--                </el-tab-pane>-->
                <el-tab-pane name="stockreturn" :label="$t('promanagement_return_application')"  class="tabWidth">
                    <div v-if="tabIndex == 'stockreturn'">
                        <stockreturn-list :formvalue="formvalue" ref="stockreturnlist"></stockreturn-list>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </template>
    </div>
</template>

<script>
    import * as API from "./api"
    import ProDetails from "./task/ProDetails";
    import EntrustDetails from "./task/EntrustDetails";
    import RequisitionApplication from "./pick/RequisitionApplication";
    import ConsumeList from "./consume/ConsumeList";
    import OutputConsumpe from "./consume/OutputConsumpe";
    import WarehouseApplication from "./putinwarehouse/WarehouseApplication";
    import DeliverList from "./deliver/DeliverList";
    import StockreturnList from "./stockreturn/StockreturnList";

    export default {
        name: "TabsList",
        components: {
            ConsumeList, RequisitionApplication, EntrustDetails, ProDetails,OutputConsumpe,WarehouseApplication,DeliverList,StockreturnList},
        props:{
            tabslist:{
                type:Object,
                required:true,
            },
            datevalue:{
                type:String
            }
        },
        data() {
            return {
                show:false,
                formvalue:{},
                tabIndex:'tasks',
                i_type:3,
                i_show:1,
            }
        },
        watch:{
            datevalue(){
                if (this.datevalue){
                    this.i_type=3
                    // console.log(this.formvalue,"this.formvalue");

                }
            },
            tabslist(){
                if (this.tabslist){
                    //console.log('this.tabslist',this.tabslist)
                    //this.i_type=this.tabslist.i_type;
                    this.i_type=0;
                    this.i_show=this.tabslist.i_show;
                    this.formvalue=this.tabslist;
                    //console.log(this.formvalue,"this.formvalue");

                }
            },
            immediate:true,
            deep:true
        },
        mounted() {
           //console.log(this.formvalue,"this.formvalue");
        },
        methods: {
            handleClick(tab){
                // console.log(tab.name,'tab')
                this.tabIndex = tab.name;
                if (this.tabIndex=='tasks'){
                    // this.getEntrustCompanyHaveList();
                }
                // else if(this.tabIndex==1){
                //     this.$refs.forChildren.getPickingReqList() //父组件调子组件
                // }
            },
            proDetails(val){
                //console.log(val,"proDetails-val");
                this.$emit('refreshTask',val);
                // console.log("proDetails")
            },
            /*entrustDetails(){
                console.log("entrustDetails")
            }*/

        },
    }
</script>

<style lang="scss" scoped>
    .el-tabs--border-card{
        height:calc(100% - 5px);

        /*height: 95%;*/
        /*max-height: calc(80vh);
        min-height: calc(40vh);*/
        //min-height: calc(90vh - 180px)
    }
/*.tabWidth{
    min-width: 960px;
}*/

   /* @media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 370px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 500px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 460px;
        }
    }*/

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
    }
    /deep/{
        .el-tabs__item{
            height: 32px;
            line-height: 32px;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev{
            line-height: 32px;
        }
    }

</style>